import { Alert }          from '@/components/ui/alert';
import Box                from '@/components/box/Box'
import { Button }         from '@/components/ui/button';
import EmailModal         from '@/pages/Security/modals/EmailModal';
import React              from 'react';
import { Stack }          from '@chakra-ui/react';
import { Text }           from '@chakra-ui/react';
import authStore          from '@/stores/authStore';
import { toaster }        from '@/components/ui/toaster';
import { useTranslation } from 'react-i18next';

const EmailBox = () => {
	const { t } = useTranslation();
	const currentUser = authStore.currentUser;
	const [emailModalIsOpen, setEmailModalIsOpen] = React.useState(false);
	const [showAlertMessage, setShowAlertMessage] = React.useState(false);
	const [newEmail, setNewEmail] = React.useState('');

	const onChangeEmailSuccess = (newEmail: string) => {
		setNewEmail(newEmail);
		setShowAlertMessage(true);
		toaster.create({
			title: t('pages.security.emailBox.modals.forms.messages.success', { email: currentUser?.email }),
			type: 'success',
		})
	}

	return (
		<Box>
			<EmailModal isOpen={emailModalIsOpen} setIsOpen={setEmailModalIsOpen} onChangeEmailSuccess={onChangeEmailSuccess} />
			{
				newEmail && showAlertMessage && <Alert status="info" title={t('pages.security.emailBox.modals.forms.messages.success', { email: newEmail })} />
			}
			<Stack gap="10px">
				<Text className="poppins-semibold" fontSize="16px">{t('pages.security.emailBox.title')}</Text>
				<Text>{currentUser.email}</Text>
			</Stack>
			<Button onClick={() => {
				setShowAlertMessage(false);
				setEmailModalIsOpen(true);
			}}>{t('pages.security.emailBox.actions.edit')}</Button>
		</Box>
	);
};

export default EmailBox;